<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="12" md="6" xl="6">
                  <BaseInput
                    :options="codeInput.options"
                    :data="codeInput.data"
                  />
             
                </CCol>

                <CCol sm="12" md="6" xl="6">
                    <BaseInput
                        :options="nameInput.options"
                        :data="nameInput.data"
                    />
                </CCol>

                <CCol sm="12" md="6" xl="6">
                    <BaseInput
                    :options="fromDate.options"
                    :data="fromDate.data"
                  />
                </CCol>

                <CCol sm="12" md="6" xl="6">
                  
                  <BaseInput
                    :options="toDate.options"
                    :data="toDate.data"
                  />
                </CCol>

                <CCol sm="12" md="6" xl="6">
                    <BaseInput
                        :options="discountInput.options"
                        :data="discountInput.data"
                    />
                </CCol>

                <!-- <CCol sm="12" md="6" xl="6">
                    <BaseSelect
                        :options="isActiveSelect.options"
                        :data="isActiveSelect.data"
                        ref="isActive"
                    >
                    </BaseSelect>
                </CCol> -->
                 
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData"
                >
                  <i class="fa fa-refresh"></i> Cập nhật
                </CButton
                >
                <CButton
                  color="success"
                  class="btn-action-primary mr-2"
                  @click="selectProduct('selectProduct', null)"
                >
                  <i class="fa fa-plus"></i> Thêm sản phẩm
                </CButton
                >
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.push('/sale-program-management/managed-sale-program')"
                ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>


    <CCard>
      <CCardHeader>
        <h5>Danh sách sản phẩm trong khuyến mại</h5>
      </CCardHeader>
      <CCardBody>
        <ProductSaleProgramList ref="productSaleProgramList"></ProductSaleProgramList>
      </CCardBody>
    </CCard>

    <SelectProduct
        :actionTypeMapping="actionData.actionSelectProduct"
        ref="actionSelectProduct"
        >      
    </SelectProduct>

  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import SelectProduct from './SelectProduct.vue';
import ProductSaleProgramList from './ProductSaleProgramList.vue';

export default {
  name: "SaleProgramUpdate",
  components: {BaseSelect, BaseInput, BaseLoading, SelectProduct, ProductSaleProgramList},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;

    var actionSelectProduct = new Map();
    actionSelectProduct.set("selectProduct", {
      url: "/policy-detail/createPolicyDetail",
      dataSubmit: function () {
        return {
          id: that.actionData.model.id,
        };
      },
      successCallback: function () {
        that.showSuccessMsg({
          message: "Thêm sản phẩm vào khuyến mại thành công"
        });
        that.$refs.productSaleProgramList.loadDataMainTable();
      },
      isJsonContentType: false
    });

    return {
      loading: {value: false},

      actionData: {
        // actionTypeMapping: actionTypeMapping,
        actionSelectProduct : actionSelectProduct,
        model: {
          selectedAll: false,
          id: null,
          listProductSelected: []
        }
      },
      idField: {
        data: {
          model: that.$route.params.id,
          name: "id"
        }
      },
      codeInput: {
        options: {
          label: "Mã chương trình khuyến mại *",
          placeholder: "Mã chương trình khuyến mại",
          type: "text",
          maxlength: 100
        },
        data: {
          name: "code",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.codeInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Mã chương trình khuyến mại không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      nameInput: {
        options: {
          label: "Tên chương trình khuyến mại *",
          placeholder: "Tên chương trình khuyến mại",
          type: "text",
          maxlength: 200
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Tên chương trình khuyến mại không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      fromDate: {
        options: {
          label: "Từ ngày *",
          type: "date",
          maxlength: 200
        },
        data: {
          name: "fromDate",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.fromDate.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Từ ngày không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      toDate: {
        options: {
          label: "Đến ngày *",
          type: "date",
          maxlength: 200
        },
        data: {
          name: "toDate",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.toDate.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Đến ngày không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      discountInput: {
        options: {
          label: "Khuyến mại (%) *",
          placeholder: "Khuyến mại (%)",
          type: "number",
          maxlength: 200
        },
        data: {
          name: "discount",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.discountInput.data.model;
              if (value === "" || value === null || value == 0) {
                this.isValid = false;
                this.errorMessage = "Khuyến mại (%) không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      isActiveSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "active",
          items: [
            {key: "true", value: "Hoạt động"},
            {key: "false", value: "Không hoạt động"},
          ],
          model: 'true'
        }
      }
    };
  },
  methods: {
    getData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/sale-program/findById",
        dataSubmit: function () {
          return {id: that.idField.data.model}
        },
        isJsonContentType: false,
        successCallback: function (response) {
          let dataRes = response.data.data;
          dataRes.active = dataRes.active+"";
          dataRes.fromDate = that.$helper.formatDateYYYYMMDD(dataRes.fromDate);
          dataRes.toDate = that.$helper.formatDateYYYYMMDD(dataRes.toDate); 
          that.dataCache = that.$helper.setupDataResponse(that.$data, dataRes);
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/sale-program/updateSaleProgram",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Cập nhật chương trình khuyến mại thành công"});
            // that.$router.push("/sale-program-management/update/"+response.data.data.data.id);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    selectProduct: function (actionTypeKey, id) {
      var actionData = this.actionData.model;
      actionData.id = id || null;
      this.$refs.actionSelectProduct.setCurrAction(actionTypeKey);
      this.$refs.actionSelectProduct.actionData.model.listProductSelected = [];
      this.$refs.actionSelectProduct.codeInput.data.model = "";
      this.$refs.actionSelectProduct.nameInput.data.model = "";
      this.$refs.actionSelectProduct.loadDataMainTable(true);
    },
  },
  computed: {
  },
  created() {
    
  },
  mounted() {
    this.getData();
  },
  watch: {}
};
</script>
